import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { setCurrentCommunity, setRefetchSpecificUser } from "../../../redux/multicommunity/multicommunity";
import { storeUser } from "../../../redux/users/usersSlice";
import useImageUpload from "../../../hooks/useImageUpload";
import useApi from "../../../helpers/apiHelper/requestHelper";
import Profile from "../../../assets/images/Profile.svg";
import PlusCircle from "../../../assets/images/plus-cricle-filled-icon.svg";
import AngleDown from "../../../assets/images/dropdownAngle.svg";
import RightAngle from "../../../assets/images/rightAnglePath.svg";
import { toastify } from "../../../helpers/toast/toastify";
import { getMemberCommunityDisplayName } from "../../../helpers/memberCommunityDisplay";

const MobileCommunity = ({ communities = [], onClose = () => {} }) => {
  const selectedCommunity = useSelector(
    (state) => state?.multiCommunity?.currentCommunity
  );
  const user = useSelector((e) => e?.user?.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const api = useApi();
  const [isCommunityDropDownOpen, serIsCommunityDropDownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [logo, setLogo] = useState("");
  // Use the centralized image upload hook
  const {
    fileInputRef,
    setIsProgrammaticUpload,
    handleFileChange,
    handleIconClick,
  } = useImageUpload(selectedCommunity);

  useEffect(() => {
    if (user?.role === "leader" && !(user?.leaderCommunity)) {
      setLogo(user?.image);
    } else if (user?.role === "leader" && (user?.leaderCommunity)) {
      setLogo(selectedCommunity?.logo);
    } else if (user?.role === "member") {
      setLogo(user?.memberCommunities[0]?.community?.logo);
    }
  }, [user]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        serIsCommunityDropDownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Lock body scroll on mobile when dropdown is open
  useEffect(() => {
    if (isCommunityDropDownOpen) {
      document.body.classList.add("mobile-scroll-locked");
    } else {
      document.body.classList.remove("mobile-scroll-locked");
    }
    return () => {
      document.body.classList.remove("mobile-scroll-locked");
    };
  }, [isCommunityDropDownOpen]);
  const setSelectedCommunity = async (community) => {
    try {
      const response = await api("post", "/users/setCommunityId", {
        communityId: community.leader,
        mainLeader: community.mainLeader,
      });

      if (response?.status) {
        // toastify("Community selected successfully!", "success");
        const responseSpecificUser = await api("post", "multiCommunity/getSpecificUser", {
          id: community.leader,
        });

        localStorage.setItem("token", responseSpecificUser?.data?.token);
        dispatch(storeUser(responseSpecificUser?.data));
        dispatch(setCurrentCommunity(community));
        dispatch(setRefetchSpecificUser(true));

        serIsCommunityDropDownOpen(false);
        onClose();
        return response.data;
      } else {
        toastify(response?.message || "Failed to update community", "error");
        return null;
      }
    } catch (error) {
      console.error("[setSelectedCommunity] ❌ Error:", error);
      toastify("Something went wrong while setting community", "error");
      return null;
    }
  };

  return (
    <>
      <div className="communityProfileSelection">
        <div className="img-box" style={{ cursor: "pointer" }} onClick={() => navigate(`/${user?.role}/dashboard`)}>
          <div className="img-wrapper">
            <img src={logo || Profile} alt="" className="logo-img" />
            {((user?.role === "leader" && user.leaderCommunity && !selectedCommunity?.logo) ||
              (user?.role === "leader" && !user.image && !user?.leaderCommunity)) && (
              <>
                <img src={PlusCircle} alt="" className="plus-icon"
                  onClick={() => { setIsProgrammaticUpload(false); handleIconClick(); }}
                />
                <input type="file" ref={fileInputRef} onChange={handleFileChange}
                  accept="image/jpeg,image/jpg,image/png,image/gif" style={{ display: "none" }} />
              </>
            )}
          </div>
        </div>
        <div className="communityProfileDropdown" ref={dropdownRef}>
          {user?.role === "leader" && communities?.length > 1 ? (
            <>
              <button className="dropdown-toggle gap-2"
                onClick={() => serIsCommunityDropDownOpen(!isCommunityDropDownOpen)}>
                <span className="communityNameText">{selectedCommunity?.disPlayName}</span>
                <span className={`arrow ${isCommunityDropDownOpen ? "rotate" : ""}`}>
                  <img src={AngleDown} alt="Arrow Down" />
                </span>
              </button>
              {isCommunityDropDownOpen && (
                <div className="dropdown-menu">
                  {communities?.length > 0 && communities.map((community, index) => (
                    <div key={index}
                      className={`dropdown-item ${selectedCommunity === community ? "active" : ""}`}
                      onClick={async () => await setSelectedCommunity(community)}>
                      <p className="text">{community?.disPlayName}</p>
                      <span className="arrow"><img src={RightAngle} alt="Arrow Right" /></span>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <>
              {user?.role === "leader" && (
                <button className="dropdown-toggle">
                  <span className="communityNameText">
                    {selectedCommunity?.disPlayName || user?.tradeName || user?.mainLeader?.tradeName}
                  </span>
                </button>
              )}
            </>
          )}
          {(user?.role === "member" || user?.role === "memberNoLink") && (
            <button className="dropdown-toggle">
              <span className="communityNameText">
                {getMemberCommunityDisplayName(user)}
              </span>
            </button>
          )}
          {/* memberNoLink community name handled above via getMemberCommunityDisplayName */}
        </div>
      </div>
    </>
  );
};

export default MobileCommunity;